import { render, staticRenderFns } from "./shareMedia.vue?vue&type=template&id=16ba3bef&scoped=true"
import script from "./shareMedia.vue?vue&type=script&lang=js"
export * from "./shareMedia.vue?vue&type=script&lang=js"
import style0 from "./shareMedia.vue?vue&type=style&index=0&id=16ba3bef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba3bef",
  null
  
)

export default component.exports